import { useMutation } from '@tanstack/react-query';

import { analyticServices } from '@hero/services';

export const useThankYouMessagesReport = options => {
  return useMutation(body => analyticServices.getThankYouMessagesReport(body), {
    ...options
  });
};
